import React from "react";
import { RouteObject } from "react-router-dom";
import withSuspense from "../../components/wrappers/WithSuspense";

const Users = React.lazy(() => import("../users/pages/Users"));
const CreateUser = React.lazy(() => import("../users/pages/CreateUser"));
const User = React.lazy(() => import("../users/pages/User"));
const userLayout = React.lazy(() => import("../users/index"));

export const internalUsersRoutes: RouteObject[] = [
  {
    path: "",
    element: withSuspense(userLayout),
    children: [
      {
        path: "",
        element: withSuspense(Users),
      },
      {
        path: ":email",
        element: withSuspense(User),
      },
      {
        path: "create",
        element: withSuspense(CreateUser),
      },
    ],
  },
];
